import * as React from "react"
import { CSSProperties, useState } from "react"
import { connect } from "react-redux"
import { message, Spin, Upload } from "antd"
import { Color } from "../../constants"
import { getHttpHeaders } from "../auth/selectors"
import { uploadFileApiRequest } from "../../api/uploadImage"
import type { HttpHeaders } from "../../api/types"
import { AntdIconWrap } from "../uiKit/Icons/AntdIconWrap"

type Props = {
    title?: string | React.ReactNode
    subtitle?: string | React.ReactNode
    maxSize?: number
    onUpload: (filePath: string) => void
    httpHeaders: HttpHeaders
}

/** @deprecated - use <ImageUpload /> component from 'uiKit' folder instead */
const UploadImageLegacy = ({
    title = "Upload Image",
    subtitle = (
        <div>
            <span style={styles.underline}>Browse</span> or drag & drop (.JPG or .PNG, max 2 MB)
        </div>
    ),
    maxSize = 2048,
    onUpload,
    httpHeaders,
}: Props) => {
    const [isUploading, setIsUploading] = useState(false)
    const onDrop = async file => {
        setIsUploading(true)

        if (file.size / 1024 > maxSize) {
            message.error("Could not upload image: Image size exceeds " + (maxSize / 1024).toFixed(2) + "MB")
            setIsUploading(false)
            return
        }

        const fileB64 = await fileToBase64(file)

        if (fileB64 && typeof fileB64 === "string") {
            const result = await uploadFileApiRequest(httpHeaders, fileB64, file.name)
            onUpload(result.url)
        }

        setIsUploading(false)
    }

    return (
        <Upload.Dragger
            accept=".png, .jpg, .jpeg"
            style={styles.container}
            name="file"
            disabled={isUploading}
            beforeUpload={onDrop}
            // @ts-expect-error
            underline={true}
            fileList={[]}>
            {isUploading && (
                <div style={styles.loadingContainer}>
                    <Spin
                        style={{
                            marginRight: "6px",
                            marginBottom: "-1px",
                        }}
                    />
                    <div>Uploading Image...</div>
                </div>
            )}
            <div style={styles.label}>
                <AntdIconWrap type="plus" style={styles.icon} />
                {title}
            </div>
            <div style={styles.subLabel}>{subtitle}</div>
        </Upload.Dragger>
    )
}

const styles: Record<string, CSSProperties> = {
    container: {
        width: "100%",
        padding: "0.8rem",
        lineHeight: 1,
        cursor: "pointer",
        position: "relative",
    },
    loadingContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pointerEvents: "none",
        position: "absolute",
        zIndex: 999,
        background: "#fafafa",
        marginTop: "calc(-0.8rem + 1px)",
        marginLeft: "calc(-0.8rem + 1px)",
    },
    label: {
        color: "#111",
        marginBottom: "6px",
    },
    icon: {
        color: "#999",
        marginRight: "6px",
        fontSize: "16px",
        marginBottom: "-1px",
    },
    subLabel: {
        fontSize: "13px",
        color: "#999",
    },
    underline: {
        color: Color.PrimaryColor,
        textDecoration: "underline",
    },
}

const fileToBase64 = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)

        reader.onload = _ => resolve(reader.result)

        reader.onerror = e => reject(e)
    })
}

const mapStateToProps = state => ({
    httpHeaders: getHttpHeaders(state),
})

export default connect<any, any, any>(mapStateToProps, {})(UploadImageLegacy)
